import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Text } from 'v3/components';
import usePermission from 'hooks/usePermission';

// Link para o cadastro completo da transportadora vinculada (FR-004). O cooperplace-api não expõe rota
// própria para isso: a URL é montada a partir do shippingCompanyId que vem na solicitação.
export default function ShippingCompanyLink({ shippingCompanyId }) {
  const canViewShippingCompany = usePermission('VISUALIZAR_TRANSPORTADORAS');

  if (!shippingCompanyId || !canViewShippingCompany) return null;

  return (
    <Link to={`/transportadoras/${shippingCompanyId}`} data-testid="shipping-company-link">
      <Button variant="secondary" size="sm">
        <Text color="dark" weight={500} type="regular">
          Ver cadastro da transportadora
        </Text>
      </Button>
    </Link>
  );
}
